import {
  Modal,
  Form,
  FormGroup,
  ModalHeader,
  Col,
  Label,
  Input,
} from "reactstrap";
import 'assets/css/admin_user_filters_modal.css'

import React, { useEffect, useState } from 'react';
import { useFormik } from "formik";
import Select from "react-select";
import { filterLeadTypeOptions, getFilterModalLatestDateValue, getIANATimezoneStringForAbbreviation, getJsonStringForFilters, getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";
import { CALLS_FILTERED_COLUMNS_OBJECTS, CALLS_STATUS_OPTIONS, COMPARISON_FIELD_OPTIONS, LEAD_TYPES, LEAD_TYPES_OPTIONS, PRODUCT_TYPE_IDS, REQUIRED_FEATURE_FLAGS, YesNoOptionsWithBooleanValues } from 'helpers/sf_constants';
import { usStatesOptions } from "common/data/us_states";
import DateRangePicker, { DATE_RANGE_OPTIONS, createOption } from 'components/Common/DateRangePicker';
import { useMemo } from "react";
import NumberFormat from "react-number-format";
import { CALL_STATUS_OPTIONS, NEW_CALL_STATUS_OPTIONS } from "helpers/CustomFilters/prospect_filter_helper";
import useFeatureFlags from "hooks/useFeatureFlags";

const filtersForLeads = Object.values(CALLS_FILTERED_COLUMNS_OBJECTS)

const CallFilterModal = ({ isActive, modalState, currentAccountTimeZone, onSubmitModalState, onClickModalClose, campaignOptions, brandList, show_rtb_brand_ui_changes }) => {
  const [isFeatureFlagActive] = useFeatureFlags();
  const [selectedFilterName, setSelectedFilterName] = useState('');

  let modalStateDateOption = getFilterModalLatestDateValue(currentAccountTimeZone, DATE_RANGE_OPTIONS.THIS_MONTH, modalState?.received_value_label, modalState?.received_value)

  const [selectedDateRange, setSelectedDateRange] = useState(modalStateDateOption);
  const [selectedStatus, setSelectedStatus] = useState(getOptionFromValueForSelectBox(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MULTIPLE_CALL_FILTERS) ? NEW_CALL_STATUS_OPTIONS : CALL_STATUS_OPTIONS, modalState?.status_value || null) || null);
  const [selectedCountryState, setSelectedCountryState] = useState(getOptionFromValueForSelectBox(usStatesOptions, modalState?.state_value) || null);
  const [selectedCallDuration, setSelectedCallDuration] = useState(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_call_duration_value) || COMPARISON_FIELD_OPTIONS[2]);
  const [selectedDrivers, setSelectedDrivers] = useState(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_drivers_value) || COMPARISON_FIELD_OPTIONS[2]);
  const [selectedVehicles, setSelectedVehicles] = useState(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_vehicles_value) || COMPARISON_FIELD_OPTIONS[2]);
  const [selectedInsured, setSelectedInsured] = useState(getOptionFromValueForSelectBox(YesNoOptionsWithBooleanValues, modalState?.insured_value) || null);
  const [selectedBillable, setSelectedBillable] = useState(getOptionFromValueForSelectBox(YesNoOptionsWithBooleanValues, modalState?.billable_value) || null);
  const [callDurationValue, setCallDurationValue] = useState();
  const [selectedLeadType, setSelectedLeadType] = useState(getOptionFromValueForSelectBox(LEAD_TYPES_OPTIONS, modalState?.lead_type_value) || null);
  const [selectedCallDisposition, setSelectedCallDisposition] = useState(getOptionFromValueForSelectBox(CALLS_STATUS_OPTIONS, modalState?.disposition_value) || null);
  const [selectedCampaign, setSelectedCampaign] = useState(getOptionFromValueForSelectBox(campaignOptions, modalState?.campaign_name_value) || null);
  const [selectedBrand, setSelectedBrand] = useState(getOptionFromValueForSelectBox(brandList, modalState?.brand_name_value) || null)
  const searchFilters = useMemo(() => {
    let filtersOfFilters = filtersForLeads.map(single => single.fieldName)
    if (selectedFilterName.length > 0) {
      filtersOfFilters = filtersOfFilters.filter((single_object, index) => filtersForLeads[index]?.name?.toLowerCase().includes(selectedFilterName.toLowerCase()))
    }
    return filtersOfFilters
  }, [selectedFilterName])

  useEffect(() => {
    if (modalState?.received_value_label) {
      setSelectedDateRange(modalStateDateOption);
    }
  }, [modalState])


  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      ...modalState
    },
    onSubmit: (values, { resetForm }) => {
      onSubmitModalState({
        ...values,
        state_value: getJsonStringForFilters(selectedCountryState),
        received_value: JSON.stringify(selectedDateRange?.value) || "",
        received_value_label: selectedDateRange?.original_label,
        call_duration_value: callDurationValue || "",
        selected_drivers_value: selectedDrivers?.value || "",
        selected_call_duration_value: selectedCallDuration?.value || "",
        selected_vehicles_value: selectedVehicles?.value || "",
        insured_value: getJsonStringForFilters(selectedInsured),
        billable_value: getJsonStringForFilters(selectedBillable),
        campaign_name_value: getJsonStringForFilters(selectedCampaign),
        brand_name_value: getJsonStringForFilters(selectedBrand),
        lead_type_value: getJsonStringForFilters(selectedLeadType),
        disposition_value: getJsonStringForFilters(selectedCallDisposition),
        status_value: getJsonStringForFilters(selectedStatus)
      });
    }
  });

  const handleCallDurationValue = (e) => {
    const { value } = e.target;
    const number = value.replace(/[^0-9]/g, '');
    setCallDurationValue(number);
  }


  const handleCountryState = (selectedObj) => {
    setSelectedCountryState(selectedObj);
  }

  const handleSelectedCallDuration = (selectedObj) => {
    setSelectedCallDuration(selectedObj);
  }

  const handleDisposition = (selectedObj) => {
    setSelectedCallDisposition(selectedObj);
  }

  const handleSelectedDrivers = (selectedObj) => {
    setSelectedDrivers(selectedObj);
  }

  const handleSelectedVehicles = (selectedObj) => {
    setSelectedVehicles(selectedObj);
  }

  const handleSelectedCampaign = (selectedObj) => {
    setSelectedCampaign(selectedObj);
  }

  const handleSelectedBrand = (selectedObj) => {
    setSelectedBrand(selectedObj);
  }

  const handleLeadType = (selectedObj) => {
    setSelectedLeadType(selectedObj);
  }

  const handleStatus = (selectedObj) => {
    setSelectedStatus(selectedObj);
  }

  const setDropdownValues = () => {
    setSelectedStatus(JSON.parse(modalState?.status_value || "[]") || null);
    setSelectedCallDuration(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_call_duration_value) || COMPARISON_FIELD_OPTIONS[2]);
    setCallDurationValue(modalState?.call_duration_value || "");
    setSelectedInsured(getOptionFromValueForSelectBox(YesNoOptionsWithBooleanValues, JSON.parse(modalState?.insured_value || '{}')?.value) || null);
    setSelectedBillable(getOptionFromValueForSelectBox(YesNoOptionsWithBooleanValues, JSON.parse(modalState?.billable_value || '{}')?.value) || null);
    setSelectedCountryState(JSON.parse(modalState?.state_value || "[]") || null);
    setSelectedCampaign(JSON.parse(modalState?.campaign_name_value || "[]") || null);
    setSelectedBrand(JSON.parse(modalState?.brand_name_value || "[]") || null);
    setSelectedLeadType(JSON.parse(modalState?.lead_type_value || "[]") || null);
    setSelectedCallDisposition(JSON.parse(modalState?.disposition_value || "[]") || null);
    setSelectedDrivers(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_drivers_value) || COMPARISON_FIELD_OPTIONS[2]);
    setSelectedVehicles(getOptionFromValueForSelectBox(COMPARISON_FIELD_OPTIONS, modalState?.selected_vehicles_value) || COMPARISON_FIELD_OPTIONS[2]);
  }

  return (
    <Modal className="filter admin-filter-users"
      isOpen={isActive}
      backdrop={true}
      fade={false}
      onOpened={() => {
        setDropdownValues()
      }}
      backdropClassName="no-backdrop-color"
      toggle={onClickModalClose}
      scrollable={true}
    >
      <ModalHeader>
        <span className="modal-title text-black">Filters</span>
        <button type="button" className="close" onClick={onClickModalClose} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <div className="sf-admin-filters-position-relative">
        <Form onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}>
          <div className="mx-3" style={{ minHeight: '50vh' }}>
            <Col md="auto" className='align-self-center mt-3'>
              <FormGroup className="mb-0">
                <div className="search-box me-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                      className="rounded sf-box-w"
                      value={selectedFilterName}
                      placeholder="Search Filters"
                      onChange={(e) => {
                        setSelectedFilterName(e.target.value);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                        }
                      }}
                    />
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </FormGroup>
            </Col>
            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.STATUS.fieldName) &&
              <FormGroup className="mt-2" id="user-status" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-status"
                    type="checkbox"
                    name="status"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.status}
                    defaultChecked={validation.values.status}
                  />
                  {' '}
                  <Label htmlFor="user-filter-status" check>Status</Label>
                </Col>

                {(validation.values.status) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-status-value"
                      name="status_value"
                      options={isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MULTIPLE_CALL_FILTERS) ? NEW_CALL_STATUS_OPTIONS : CALL_STATUS_OPTIONS}
                      onChange={handleStatus}
                      onBlur={validation.handleBlur}
                      value={selectedStatus}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}
            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.FIRST_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-first_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-first-name"
                    type="checkbox"
                    name="first_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.first_name}
                    defaultChecked={validation.values.first_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-first-name" check>
                    First Name
                  </Label>
                </Col>
                {(validation.values.first_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="first_name_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.first_name_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.LAST_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-last_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-last-name"
                    type="checkbox"
                    name="last_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.last_name}
                    defaultChecked={validation.values.last_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-last-name" check>
                    Last Name
                  </Label>
                </Col>
                {(validation.values.last_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-last-name-value"
                      type="text"
                      name="last_name_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.last_name_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.PHONE.fieldName) &&
              <FormGroup className="mt-2" id="user-phone_num" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-phone_num"
                    type="checkbox"
                    name="phone_num"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone_num}
                    defaultChecked={validation.values.phone_num}
                  />
                  {' '}
                  <Label htmlFor="user-filter-phone_num" check>
                    Phone
                  </Label>
                </Col>
                {(validation.values.phone_num) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="phone_num_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.phone_num_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.CALL_DURATION.fieldName) &&
              <FormGroup className="mt-2" id="user-call-duration" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-call-duration"
                    type="checkbox"
                    name="call_duration"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.call_duration}
                    defaultChecked={validation.values.call_duration}
                  />
                  {' '}
                  <Label htmlFor="user-filter-call-duration" check>
                    Call Duration
                  </Label>
                </Col>
                {(validation.values.call_duration) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-account-number-selectValue"
                      name="selected_call_duration_value"
                      options={COMPARISON_FIELD_OPTIONS}
                      onChange={handleSelectedCallDuration}
                      value={selectedCallDuration}
                    />
                  </Col>
                  <Col sm={12} className="mt-2">
                    <NumberFormat
                      className="form-control"
                      type="text"
                      suffix=" sec"
                      allowNegative={false}
                      placeholder="sec"
                      name="call_duration_value"
                      autoComplete="off"
                      onChange={handleCallDurationValue}
                      onBlur={validation.handleBlur}
                      onKeyDown={validation.handleKeyDown}
                      value={callDurationValue}
                      allowEmptyFormatting={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.INSURED.fieldName) &&
              <FormGroup className="mt-2" id="user-insured" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-insured"
                    type="checkbox"
                    name="insured"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.insured}
                    defaultChecked={validation.values.insured}
                  />
                  {' '}
                  <Label htmlFor="user-filter-insured" check>
                    Insured
                  </Label>
                </Col>
                {(validation.values.insured) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-insured-selectValue"
                      name="insured_value"
                      options={YesNoOptionsWithBooleanValues}
                      onChange={option => {
                        setSelectedInsured(option);
                      }}
                      value={selectedInsured}
                    />
                  </Col>
                </>)}
              </FormGroup>
            }

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.BILLABLE.fieldName) &&
              <FormGroup className="mt-2" id="user-call-billable" row check>
                <Col sm={12} >
                  <Input
                    id="user-call-filter-billable"
                    type="checkbox"
                    name="billable"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.billable}
                    defaultChecked={validation.values.billable}
                  />
                  {' '}
                  <Label htmlFor="user-call-filter-billable" check>
                    {CALLS_FILTERED_COLUMNS_OBJECTS.BILLABLE.name}
                  </Label>
                </Col>
                {(validation.values.billable) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-insured-selectValue"
                      name="billable_value"
                      options={YesNoOptionsWithBooleanValues}
                      onChange={option => {
                        setSelectedBillable(option);
                      }}
                      value={selectedBillable}
                    />
                  </Col>
                </>)}
              </FormGroup>
            }

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.ADDRESS.fieldName) &&
              <FormGroup className="mt-2" id="user-address" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-address"
                    type="checkbox"
                    name="address"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address}
                    defaultChecked={validation.values.address}
                  />
                  {' '}
                  <Label htmlFor="user-filter-address" check>
                    Address
                  </Label>
                </Col>
                {(validation.values.address) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-address-value"
                      type="text"
                      name="address_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.address_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.CITY.fieldName) &&
              <FormGroup className="mt-2" id="user-city" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-city"
                    type="checkbox"
                    name="city"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.city}
                    defaultChecked={validation.values.city}
                  />
                  {' '}
                  <Label htmlFor="user-filter-city" check>
                    City
                  </Label>
                </Col>
                {(validation.values.city) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="city_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.city_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.ZIP_CODE.fieldName) &&
              <FormGroup className="mt-2" id="user-zip_code" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-zip_code"
                    type="checkbox"
                    name="zip_code"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.zip_code}
                    defaultChecked={validation.values.zip_code}
                  />
                  {' '}
                  <Label htmlFor="user-filter-zip_code" check>
                    Zip Code
                  </Label>
                </Col>
                {(validation.values.zip_code) && (<>
                  <Col sm={12} className="mt-2">
                    <Input
                      id="user-filter-first-name-value"
                      type="text"
                      name="zip_code_value"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.zip_code_value}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.STATE.fieldName) &&
              <FormGroup className="mt-2" id="user-state" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-state"
                    type="checkbox"
                    name="state"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.state}
                    defaultChecked={validation.values.state}
                  />
                  {' '}
                  <Label htmlFor="user-filter-state" check>
                    State
                  </Label>
                </Col>

                {(validation.values.state) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-first-name-value"
                      name="state_value"
                      options={usStatesOptions}
                      onChange={handleCountryState}
                      onBlur={validation.handleBlur}
                      value={selectedCountryState}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.CAMPAIGN_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-campaign_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-campaign-name"
                    type="checkbox"
                    name="campaign_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.campaign_name}
                    defaultChecked={validation.values.campaign_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-campaign-name" check>
                    Campaign Name
                  </Label>
                </Col>
                {(validation.values.campaign_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-campaign-name-value"
                      name="campaign_name_value"
                      options={campaignOptions}
                      onChange={handleSelectedCampaign}
                      onBlur={validation.handleBlur}
                      value={selectedCampaign}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.LEAD_TYPE.fieldName) &&
              <FormGroup className="mt-2" id="user-lead_type" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-lead-type"
                    type="checkbox"
                    name="lead_type"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lead_type}
                    defaultChecked={validation.values.lead_type}
                  />
                  {' '}
                  <Label htmlFor="user-filter-lead-type" check>
                    Type
                  </Label>
                </Col>

                {(validation.values.lead_type) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-first-name-value"
                      name="lead_type_value"
                      options={
                        filterLeadTypeOptions(
                          PRODUCT_TYPE_IDS.CALLS,
                          LEAD_TYPES,
                          {
                            motorcycle_lead_type: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MOTORCYCLE_LEAD_TYPE_FOR_CLICKS),
                            group_health_lead_type: isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE)
                          }
                        )
                      }
                      onChange={handleLeadType}
                      onBlur={validation.handleBlur}
                      value={selectedLeadType}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.DISPOSITION.fieldName) &&
              <FormGroup className="mt-2" id="user-disposition" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-disposition"
                    type="checkbox"
                    name="disposition"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.disposition}
                    defaultChecked={validation.values.disposition}
                  />
                  {' '}
                  <Label htmlFor="user-filter-disposition" check>
                    Disposition
                  </Label>
                </Col>

                {(validation.values.disposition) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-status-value"
                      name="disposition_value"
                      options={CALLS_STATUS_OPTIONS}
                      onChange={handleDisposition}
                      onBlur={validation.handleBlur}
                      value={selectedCallDisposition}
                      isMulti={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.RECEIVED.fieldName) &&
              <FormGroup className="mt-2" id="user-received" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-received"
                    type="checkbox"
                    name="received"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.received}
                    defaultChecked={validation.values.received}
                  />
                  {' '}
                  <Label htmlFor="user-filter-received" check>
                    Received
                  </Label>
                </Col>
                {(validation.values.received) && (<>
                  <Col sm={12} className="mt-2">
                    <DateRangePicker
                      ianaTz={getIANATimezoneStringForAbbreviation(currentAccountTimeZone)}
                      value={selectedDateRange}
                      options={Object.keys(DATE_RANGE_OPTIONS).map((opt) => createOption(
                        DATE_RANGE_OPTIONS[opt],
                        new Date(),
                        getIANATimezoneStringForAbbreviation(currentAccountTimeZone),
                      ))}
                      onChange={(value) => {
                        setSelectedDateRange(value);
                      }}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.DRIVERS.fieldName) &&
              <FormGroup className="mt-2" id="user-drivers" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-drivers"
                    type="checkbox"
                    name="drivers"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.drivers}
                    defaultChecked={validation.values.drivers}
                  />
                  {' '}
                  <Label htmlFor="user-filter-drivers" check>
                    Applicants
                  </Label>
                </Col>
                {(validation.values.drivers) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-drivers-selectValue"
                      name="selected_drivers_value"
                      options={COMPARISON_FIELD_OPTIONS}
                      onChange={handleSelectedDrivers}
                      value={selectedDrivers}
                    />
                  </Col>
                  <Col sm={12} className="mt-2">
                    <NumberFormat
                      className="form-control"
                      type="text"
                      allowNegative={false}
                      name="drivers_value"
                      autoComplete="off"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      onKeyDown={validation.handleKeyDown}
                      value={validation.values.drivers_value}
                      allowEmptyFormatting={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.VEHICLES.fieldName) &&
              <FormGroup className="mt-2" id="user-vehicles" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-vehicles"
                    type="checkbox"
                    name="vehicles"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.vehicles}
                    defaultChecked={validation.values.vehicles}
                  />
                  {' '}
                  <Label htmlFor="user-filter-vehicles" check>
                    Vehicles
                  </Label>
                </Col>
                {(validation.values.vehicles) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      id="user-filter-account-number-selectValue"
                      name="selected_call_duration_value"
                      options={COMPARISON_FIELD_OPTIONS}
                      onChange={handleSelectedVehicles}
                      value={selectedVehicles}
                    />
                  </Col>
                  <Col sm={12} className="mt-2">
                    <NumberFormat
                      className="form-control"
                      type="text"
                      allowNegative={false}
                      name="vehicles_value"
                      autoComplete="off"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      onKeyDown={validation.handleKeyDown}
                      value={validation.values.vehicles_value}
                      allowEmptyFormatting={true}
                    />
                  </Col>
                </>)}
              </FormGroup>}

            {show_rtb_brand_ui_changes && searchFilters.includes(CALLS_FILTERED_COLUMNS_OBJECTS.BRAND_NAME.fieldName) &&
              <FormGroup className="mt-2" id="user-brand_name" row check>
                <Col sm={12} >
                  <Input
                    id="user-filter-brand-name"
                    type="checkbox"
                    name="brand_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.brand_name}
                    defaultChecked={validation.values.brand_name}
                  />
                  {' '}
                  <Label htmlFor="user-filter-brand-name" check>
                    Brand
                  </Label>
                </Col>
                {(validation.values.brand_name) && (<>
                  <Col sm={12} className="mt-2">
                    <Select
                      id="user-filter-brand-name-value"
                      name="brand_name_value"
                      options={brandList}
                      onChange={handleSelectedBrand}
                      onBlur={validation.handleBlur}
                      value={selectedBrand}
                      isMulti={true}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      menuPlacement="top"
                    />
                  </Col>
                </>)}
              </FormGroup>}

          </div>
          <div className="modal-footer d-flex flex-wrap bg-white sf-admin-filters-position-sticky gap-2 pt-3">
            <button className={`btn ${getPrimaryButtonClass()} btn-sm`} type="submit">Update</button>
            <button className="btn btn-light btn-sm" type="reset" onClick={onClickModalClose}>Cancel</button>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

export default CallFilterModal